export enum EstimateAccuracy {
    OrderOfMagnitude = 'OrderOfMagnitude',
    Detailed = 'Detailed',
}

export const EstimateAccuracyLabels: Record<EstimateAccuracy | string, string> = {
    OrderOfMagnitude: 'Order of Magnitude',
    Detailed: 'Detailed',
};
